import { createTheme } from '@mui/material/styles';

const { breakpoints } = createTheme();

const theme = createTheme({
  palette: {
    primary: {
      light: '#edfff8',
      main: '#29cc8b',
      dark: '#00a36a',
      contrastText: '#000',
    },
    secondary: {
      light: '#79ffc9',
      main: '#EDFFF8',
      dark: '#00a36a',
      contrastText: '#000',
    },
    error: {
      light: '#fff2f4',
      main: '#FC5A5A',
      dark: '#c32130',
      contrastText: '#000',
    },
    warning: {
      light: '#fff9ec',
      main: '#FFC542',
      dark: '#ffc800',
      contrastText: '#000',
    },
    info: {
      light: '#edf7ff',
      main: '#336FFF',
      dark: '#1a3f99',
      contrastText: '#000',
    },
    success: {
      light: '#e9f9f3',
      main: '#29cc8b',
      dark: '#1c8d63',
      contrastText: '#000',
    },
    text: {
      disabled: '#92929D',
      hint: '#B4B4B9',
      primary: '#000000',
      secondary: '#44444F',
      main: '#FFFFFF',
    },
    background: {
      default: '#FAFBFC',
      paper: '#FFFFFF',
      lightGreen: '#29CC8B1A',
      lightRed: '#F443361A',
    },
    grey: {
      100: '#dfdfdf',
      200: '#E2E8EE',
      500: '#B4B4B9',
    },
    icon: {
      secondary: '#2A374A',
      dimmed: '#00000042',
    },
  },
  typography: {
    fontFamily: ['Avenir', 'Roboto', 'monospace'].join(','),
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightBold: 600,
    heading1: {
      fontFamily: ['Avenir', 'Roboto', 'monospace'].join(','),
      [breakpoints.up('xs')]: {
        fontSize: '16px',
      },
      [breakpoints.up('sm')]: {
        fontSize: '20px',
      },
      [breakpoints.up('md')]: {
        fontSize: '23px',
      },
    },
    heading2: {
      fontFamily: ['Avenir', 'Roboto', 'monospace'].join(','),
      [breakpoints.up('xs')]: {
        fontSize: '16px',
      },
      [breakpoints.up('sm')]: {
        fontSize: '18px',
      },
      [breakpoints.up('md')]: {
        fontSize: '20px',
      },
    },
    heading3: {
      fontFamily: ['Avenir', 'Roboto', 'monospace'].join(','),
      [breakpoints.up('xs')]: {
        fontSize: '15px',
      },
      [breakpoints.up('sm')]: {
        fontSize: '16px',
      },
      [breakpoints.up('md')]: {
        fontSize: '18px',
      },
    },
    heading4: {
      fontFamily: ['Avenir', 'Roboto', 'monospace'].join(','),
      [breakpoints.up('xs')]: {
        fontSize: '14px',
      },
      [breakpoints.up('sm')]: {
        fontSize: '15px',
      },
      [breakpoints.up('md')]: {
        fontSize: '16px',
      },
    },
    heading5: {
      fontFamily: ['Avenir', 'Roboto', 'monospace'].join(','),
      [breakpoints.up('xs')]: {
        fontSize: '14px',
      },
      [breakpoints.up('sm')]: {
        fontSize: '14px',
      },
      [breakpoints.up('md')]: {
        fontSize: '15px',
      },
    },
    heading6: {
      fontFamily: ['Avenir', 'Roboto', 'monospace'].join(','),
      [breakpoints.up('xs')]: {
        fontSize: '14px',
      },
      [breakpoints.up('sm')]: {
        fontSize: '14px',
      },
      [breakpoints.up('md')]: {
        fontSize: '14px',
      },
    },
    heading7: {
      fontFamily: ['Avenir', 'Roboto', 'monospace'].join(','),
      [breakpoints.up('xs')]: {
        fontSize: '13px',
      },
      [breakpoints.up('sm')]: {
        fontSize: '14px',
      },
      [breakpoints.up('md')]: {
        fontSize: '14px',
      },
    },
    heading8: {
      fontFamily: ['Avenir', 'Roboto', 'monospace'].join(','),
      [breakpoints.up('xs')]: {
        fontSize: '10px',
      },
      [breakpoints.up('sm')]: {
        fontSize: '12px',
      },
      [breakpoints.up('md')]: {
        fontSize: '13px',
      },
    },
    heading9: {
      fontFamily: ['Avenir', 'Roboto', 'monospace'].join(','),
      [breakpoints.up('xs')]: {
        fontSize: '12px',
      },
      [breakpoints.up('sm')]: {
        fontSize: '12px',
      },
      [breakpoints.up('md')]: {
        fontSize: '12px',
      },
    },
    p1: {
      fontFamily: ['Avenir', 'Roboto', 'monospace'].join(','),
      [breakpoints.up('xs')]: {
        fontSize: '14px',
      },
      [breakpoints.up('sm')]: {
        fontSize: '15px',
      },
      [breakpoints.up('md')]: {
        fontSize: '16px',
      },
    },
    p2: {
      fontFamily: ['Avenir', 'Roboto', 'monospace'].join(','),
      [breakpoints.up('xs')]: {
        fontSize: '12px',
      },
      [breakpoints.up('sm')]: {
        fontSize: '14px',
      },
      [breakpoints.up('md')]: {
        fontSize: '14px',
      },
    },
  },
  iconSizes: {
    xl: {
      md: '35px',
      sm: '30px',
      xs: '22px',
    },
    lg: {
      md: '30px',
      sm: '25px',
      xs: '20px',
    },
    md: {
      md: '22px',
      sm: '22px',
      xs: '22px',
    },
    sm: {
      md: '20px',
      sm: '17px',
      xs: '17px',
    },
    xs: {
      md: '17px',
      sm: '17px',
      xs: '15px',
    },
  },
});

export default theme;
